'use strict';

var _inherits = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncIterator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var batch = require('it-batch');

module.exports = /*#__PURE__*/_regeneratorRuntime.mark(function trickleReduceToRoot(source, reduce, options) {
  return _regeneratorRuntime.wrap(function trickleReduceToRoot$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return trickleStream(source, reduce, options);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, trickleReduceToRoot);
});

function trickleStream(_x, _x2, _x3) {
  return _trickleStream.apply(this, arguments);
}

function _trickleStream() {
  _trickleStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(source, reduce, options) {
    var root, iteration, maxDepth, subTree, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, layer;

    return _regeneratorRuntime.wrap(function _callee2$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            iteration = 0;
            maxDepth = 1;
            subTree = root = new Root(options.layerRepeat);
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context3.prev = 5;
            _iterator = _asyncIterator(batch(source, options.maxChildrenPerNode));

          case 7:
            _context3.next = 9;
            return _iterator.next();

          case 9:
            _step = _context3.sent;
            _iteratorNormalCompletion = _step.done;
            _context3.next = 13;
            return _step.value;

          case 13:
            _value = _context3.sent;

            if (_iteratorNormalCompletion) {
              _context3.next = 30;
              break;
            }

            layer = _value;

            if (!subTree.isFull()) {
              _context3.next = 26;
              break;
            }

            if (!(subTree !== root)) {
              _context3.next = 23;
              break;
            }

            _context3.t0 = root;
            _context3.next = 21;
            return subTree.reduce(reduce);

          case 21:
            _context3.t1 = _context3.sent;

            _context3.t0.addChild.call(_context3.t0, _context3.t1);

          case 23:
            if (iteration && iteration % options.layerRepeat === 0) {
              maxDepth++;
            }

            subTree = new SubTree(maxDepth, options.layerRepeat, iteration);
            iteration++;

          case 26:
            subTree.append(layer);

          case 27:
            _iteratorNormalCompletion = true;
            _context3.next = 7;
            break;

          case 30:
            _context3.next = 36;
            break;

          case 32:
            _context3.prev = 32;
            _context3.t2 = _context3["catch"](5);
            _didIteratorError = true;
            _iteratorError = _context3.t2;

          case 36:
            _context3.prev = 36;
            _context3.prev = 37;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context3.next = 41;
              break;
            }

            _context3.next = 41;
            return _iterator.return();

          case 41:
            _context3.prev = 41;

            if (!_didIteratorError) {
              _context3.next = 44;
              break;
            }

            throw _iteratorError;

          case 44:
            return _context3.finish(41);

          case 45:
            return _context3.finish(36);

          case 46:
            if (!(subTree && subTree !== root)) {
              _context3.next = 52;
              break;
            }

            _context3.t3 = root;
            _context3.next = 50;
            return subTree.reduce(reduce);

          case 50:
            _context3.t4 = _context3.sent;

            _context3.t3.addChild.call(_context3.t3, _context3.t4);

          case 52:
            return _context3.abrupt("return", root.reduce(reduce));

          case 53:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee2, null, [[5, 32, 36, 46], [37,, 41, 45]]);
  }));
  return _trickleStream.apply(this, arguments);
}

var SubTree = /*#__PURE__*/function () {
  function SubTree(maxDepth, layerRepeat, iteration) {
    _classCallCheck(this, SubTree);

    this.maxDepth = maxDepth;
    this.layerRepeat = layerRepeat;
    this.currentDepth = 1;
    this.iteration = iteration;
    this.root = this.node = this.parent = {
      children: [],
      depth: this.currentDepth,
      maxDepth: maxDepth,
      maxChildren: (this.maxDepth - this.currentDepth) * this.layerRepeat
    };
  }

  _createClass(SubTree, [{
    key: "isFull",
    value: function isFull() {
      if (!this.root.data) {
        return false;
      }

      if (this.currentDepth < this.maxDepth && this.node.maxChildren) {
        // can descend
        this._addNextNodeToParent(this.node);

        return false;
      } // try to find new node from node.parent


      var distantRelative = this._findParent(this.node, this.currentDepth);

      if (distantRelative) {
        this._addNextNodeToParent(distantRelative);

        return false;
      }

      return true;
    }
  }, {
    key: "_addNextNodeToParent",
    value: function _addNextNodeToParent(parent) {
      this.parent = parent; // find site for new node

      var nextNode = {
        children: [],
        depth: parent.depth + 1,
        parent: parent,
        maxDepth: this.maxDepth,
        maxChildren: Math.floor(parent.children.length / this.layerRepeat) * this.layerRepeat
      };
      parent.children.push(nextNode);
      this.currentDepth = nextNode.depth;
      this.node = nextNode;
    }
  }, {
    key: "append",
    value: function append(layer) {
      this.node.data = layer;
    }
  }, {
    key: "reduce",
    value: function reduce(_reduce) {
      return this._reduce(this.root, _reduce);
    }
  }, {
    key: "_reduce",
    value: function () {
      var _reduce2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(node, reduce) {
        var _this = this;

        var children;
        return _regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                children = [];

                if (!node.children.length) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 4;
                return Promise.all(node.children.filter(function (child) {
                  return child.data;
                }).map(function (child) {
                  return _this._reduce(child, reduce);
                }));

              case 4:
                children = _context2.sent;

              case 5:
                return _context2.abrupt("return", reduce(node.data.concat(children)));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee);
      }));

      function _reduce(_x4, _x5) {
        return _reduce2.apply(this, arguments);
      }

      return _reduce;
    }()
  }, {
    key: "_findParent",
    value: function _findParent(node, depth) {
      var parent = node.parent;

      if (!parent || parent.depth === 0) {
        return;
      }

      if (parent.children.length === parent.maxChildren || !parent.maxChildren) {
        // this layer is full, may be able to traverse to a different branch
        return this._findParent(parent, depth);
      }

      return parent;
    }
  }]);

  return SubTree;
}();

var Root = /*#__PURE__*/function (_SubTree) {
  _inherits(Root, _SubTree);

  var _super = _createSuper(Root);

  function Root(layerRepeat) {
    var _this2;

    _classCallCheck(this, Root);

    _this2 = _super.call(this, 0, layerRepeat);
    _this2.root.depth = 0;
    _this2.currentDepth = 1;
    return _this2;
  }

  _createClass(Root, [{
    key: "addChild",
    value: function addChild(child) {
      this.root.children.push(child);
    }
  }, {
    key: "reduce",
    value: function reduce(_reduce3) {
      return _reduce3(this.root.data.concat(this.root.children));
    }
  }]);

  return Root;
}(SubTree);